import Lottie from 'lottie-react';
import React from 'react';
import animationData from '../../public/animations/loaderwhiteweb.json';

interface SpinnerProps {
  height?: number;
  width?: number;
  centered?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ height, width, centered = true }) => {
  return (
    <div
      className="content"
      style={centered ? { width: '100%', display: 'flex', justifyContent: 'center' } : {}} // centered added for backwards compatibility with old react-lottie version
    >
      <Lottie
        animationData={animationData}
        loop
        autoplay
        style={{
          height: height || 40,
          width: width || 40,
          ...(centered && { overflow: 'hidden', outline: 'none' }),
        }}
      />
    </div>
  );
};
export default Spinner;
